<template>
  <div class="text-center d-flex align-center justify-space-around">
    <v-tooltip
      right
      color="rgb(45, 43, 43)"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          text
          @mouseenter="test"
          v-on="on"
        >
          {{ name }}
        </v-btn>
      </template>
      <!-- style="background: black;" -->
      <div>
        <TestTable
          :loading="loading"
          :list="detail "
        />
      </div>
    </v-tooltip>
  </div>
</template>
<script>
  import TestTable from '@/views/components/viewer/components/HistoryTable.jsx'
  import { getsafe } from '@/libs/util.js'
  import {getPlacingAdsKolDetailApi} from '@/views/blogger/resourcelibrary/service.js'
  export default {
    components: {
      TestTable
    },
    props: {
      name: {
        type: String
      },
      value: {
        type: Object,
      },
      showList: {
        type: Array,
      }
    },
    data() {
      return {
        detail: null,
        loading: false,
      }
    },
    computed: {
    
    },
    methods: {
      test() {
        if (this.detail || !this.value) {
          return  
        }
        this.loading = true
        getPlacingAdsKolDetailApi({id:this.value.kol_id}).then(res => {
          this.detail = getsafe(res, 'placing_ads_records', [])
     
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
</script>